import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogAction } from '@shared/models/dialog-action';
import { DialogData } from '@shared/models/dialog-data';

@Component({
	selector: 'cass-dialog-component',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.css']
})
export class DialogComponent {

	// TODO wrap this in a service - like the UserAlertService - and refactor UserAlertDialog and this together

	formGroup!: FormGroup;
	editField!: FormControl;

	constructor (@Inject(MAT_DIALOG_DATA) public data: DialogData, private _dialogRef: MatDialogRef<DialogComponent>) {
		this.editField = new FormControl('');
		this.formGroup = new FormGroup({
			editField: this.editField
		});
	}

	onAction(actionId: string) {
		this._dialogRef.close(actionId);
	}
}
